export default "__VITE_ASSET__BOAinvh0__"